export default "__VITE_ASSET__851f4396__"